export enum AssessmentConstants {
  SET_DATE = 'assessments/SET_DATE',
  SET_TIME = 'assessments/SET_TIME',
  SET_DATE_TIME = 'assessments/SET_DATE_TIME',
  SET_PTA = 'assessments/SET_PTA',
  SET_ASSESSED_BY = 'assessments/SET_ASSESSED_BY',
  SET_ROLE_PERFORMING = 'assessments/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'assessments/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'assessments/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'assessments/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_PROCEDURE_COMPLICATIONS = 'assessments/SET_PROCEDURE_COMPLICATIONS',
  SET_ACTION = 'assessments/SET_ACTION',
  SET_GAZE = 'assessments/SET_GAZE',
  SET_FACIAL_SYMMETRY = 'assessments/SET_FACIAL_SYMMETRY',
  SET_SPEECH = 'assessments/SET_SPEECH',
  SET_LIMB_MOTOR_STRENGTH = 'assessments/SET_LIMB_MOTOR_STRENGTH',
  SET_LIMB_SENSATION = 'assessments/SET_LIMB_SENSATION',
  SET_SUSPECTED_INFECTION = 'assessments/SET_SUSPECTED_INFECTION',
  SET_SEPSIS_INDICATORS = 'assessments/SET_SEPSIS_INDICATORS',
  SET_POSSIBLE_SOURCE_OF_INFECTION = 'assessments/SET_POSSIBLE_SOURCE_OF_INFECTION',
  SET_CUSTOM_ASSESSMENTS_FIELDS_ACTION = 'assessments/SET_CUSTOM_ASSESSMENTS_FIELDS_ACTION',
  SET_CUSTOM_ASSESSMENTS_FIELDS = 'assessments/SET_CUSTOM_ASSESSMENTS_FIELDS',
  SET_CUSTOM_FIELD_OPTION = 'assessments/SET_CUSTOM_FIELD_OPTION',
  SET_RESPONSE = 'assessments/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'assessments/SET_RESPONSE_PNNV',
  SET_AUTHORIZATION = 'assessments/SET_AUTHORIZATION',
  SET_COMMENTS = 'assessments/SET_COMMENTS',
  SET_ADD_TO_TIMELINE = 'assessments/SET_ADD_TO_TIMELINE',
  SET_UPDATE_INPUT_ROWS = 'assessments/SET_UPDATE_INPUT_ROWS',
  SET_STATE = 'assessments/SET_STATE',
  SET_HIDE_NEURO_FIELDS = 'assessments/SET_HIDE_NEURO_FIELDS',
  SET_HIDE_SEPSIS_FIELDS = 'assessments/SET_HIDE_SEPSIS_FIELDS',
  CLEAR_FIELDS = 'assessments/CLEAR_FIELDS',
  SAVE_ASSESSMENT = 'assessments/SAVE_ASSESSMENT',
  ON_SELECT_ASSESSMENT = 'assessments/ON_SELECT_ASSESSMENT',
  RESET_STATE = 'assessments/RESET_STATE',
}
